import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Fab, Tooltip } from '@mui/material';
import { Info } from 'lucide-react';
import { FEATURE_HELP } from '../../data/featureHelp';
import { PAGE_HELP_BY_ROUTE } from '../../data/pageHelpRoutes';
import { PageHelpDialog, usePageHelp } from '../help/PageHelp';
import { useTranslation } from 'react-i18next';

/**
 * Global "what does this page do" affordance. Mounted once in Layout.tsx so every routed page
 * gets it automatically. Content: the page's entry in the `help` namespace (in the person's language,
 * medopd-docs 97) when the route has one, else the older English FEATURE_HELP. Renders nothing if neither has it.
 */
export function LearnMoreButton() {
  const { t } = useTranslation('ui');
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const translated = usePageHelp(PAGE_HELP_BY_ROUTE[location.pathname]);
  const content = translated ?? FEATURE_HELP[location.pathname];

  if (!content) return null;

  return (
    <>
      <Tooltip title={t('learnMoreAboutThisPage')} placement="left">
        <Fab
          size="small"
          onClick={() => setOpen(true)}
          aria-label={t('learnMoreAboutThisPage')}
          sx={{
            position: 'fixed', bottom: { xs: 16, sm: 24 }, left: { xs: 16, sm: 24 }, zIndex: (theme) => theme.zIndex.speedDial,
            bgcolor: 'background.paper', color: 'primary.main',
            border: '1px solid', borderColor: 'divider',
            '&:hover': { bgcolor: 'action.hover' },
          }}
        >
          <Info size={20} />
        </Fab>
      </Tooltip>
      <PageHelpDialog content={content} open={open} onClose={() => setOpen(false)} />
    </>
  );
}
